import axios from 'axios';
import { Urls } from './Urls';

export const fetchAllData = (setLoginData) => {
  const t0 = performance.now();
  console.debug('[fetchAllData] GET', `${Urls.BaseApiUrl}/Auth`);
  axios
    .get(`${Urls.BaseApiUrl}/Auth`)
    .then((response) => {
      console.debug(`[fetchAllData] done in ${(performance.now() - t0).toFixed(0)}ms`);
      setLoginData(response.data);
    })
    .catch((error) => {
      console.error(`[fetchAllData] failed after ${(performance.now() - t0).toFixed(0)}ms`, error.message);
    });
};
